module.exports = __webpack_public_path__ + "img/thumb_16.8fecb29d.jpg";